/**
 * 成交量饼图
 */
import Context from './context';
import Util, {
  resizeObserver,
  curryDebounce,
} from '../../util/index.js';
const defaultColor = '#ccc';
export default class VolumnPieComponent extends Context {
  constructor(args) {
    super(args);
    const {legend} = args;
    this.legend = legend;
  }
  draw() {
    const ctx = this.context;
    const data = this.data;
    const {
      left,
      top,
      width,
      height
    } = this.contentRect;
    const radius = Math.min(width / 3, height * 2 / 5);
    const centerX = left + width / 2;
    const centerY = top + height / 2;
    if (Util.isValidArray(data)) {
      let degree = - Math.PI / 2;
      for (let index in data) {
        const item = data[index];
        ctx.beginPath();
        ctx.fillStyle = item.color;
        let nextDegree = degree + item.percent * Math.PI * 2;
        if (index == 2) {
          nextDegree = Math.PI / 2;
        } else if (index == 5) {
          nextDegree = Math.PI * 3 / 2;
        }
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, degree, nextDegree);
        ctx.fill();
        degree = nextDegree;
      }
    } else {
      ctx.beginPath();
      ctx.fillStyle = defaultColor;
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.fill();
    }
    this.drawLegend();
  }
  drawLegend() {
    const {
      left,
      top,
      width,
      height
    } = this.contentRect;
    const ctx = this.context;
    const centerY = top + height / 2;
    const {leftLegend, rightLegend, fontSize, fontFamily} = this.legend;
    const space = Math.max(height / 5, fontSize * this.dpr);
    const right = left + width;
    const _drawLegend = ({textAlign, fontFamily, fontSize, x, legend}) => {
      const {text, color} = legend;
      const textArr = text.split('');
      ctx.fillStyle = color;
      ctx.font = fontSize * this.dpr + 'px ' + fontFamily;
      ctx.textAlign = textAlign;
      ctx.textBaseline = 'middle';
      ctx.fillText(textArr[0], x, centerY - space);
      ctx.fillText(textArr[1], x, centerY);
      ctx.fillText(textArr[2], x, centerY + space);
    }
    _drawLegend({
      textAlign: 'left',
      x: left,
      legend: leftLegend,
      fontSize,
      fontFamily,
    });
    _drawLegend({
      textAlign: 'right',
      x: right,
      legend: rightLegend,
      fontSize,
      fontFamily,
    });
  }
}
